import React from 'react'
import { Link } from 'react-router-dom'
import { Building2, Shield, Zap, Globe } from 'lucide-react'
import { getLogoVariant } from '../utils/brandUtils'

export const ProfessionalFooter: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="professional-footer">
      <div className="professional-footer__container">
        {/* Main Footer Content */}
        <div className="professional-footer__content">
          {/* Logo and Company Info */}
          <div className="professional-footer__brand">
            <div className="professional-footer__logo">
              <img 
                src={getLogoVariant('footer').src}
                alt={getLogoVariant('footer').alt}
              />
            </div>
            <p className="professional-footer__description">
              Professional payment platform enabling Hong Kong SMEs to accept overseas payments 
              via stablecoins with minimal FX costs and instant local bank settlements.
            </p>
            <div className="professional-footer__features">
              <div className="professional-footer__feature">
                <Shield className="professional-footer__feature-icon" />
                <span>HKMA Compliant</span>
              </div>
              <div className="professional-footer__feature">
                <Zap className="professional-footer__feature-icon" />
                <span>15min Settlement</span>
              </div>
              <div className="professional-footer__feature">
                <Globe className="professional-footer__feature-icon" />
                <span>Multi-Rail Support</span>
              </div>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="professional-footer__nav">
            <div className="professional-footer__nav-section">
              <h4 className="professional-footer__nav-title">Platform</h4>
              <ul className="professional-footer__nav-list">
                <li><Link to="/dashboard" className="professional-footer__nav-link">Dashboard</Link></li>
                <li><Link to="/payments" className="professional-footer__nav-link">Payments</Link></li>
                <li><Link to="/analytics" className="professional-footer__nav-link">Analytics</Link></li>
                <li><Link to="/settlements" className="professional-footer__nav-link">Settlements</Link></li>
              </ul>
            </div>

            <div className="professional-footer__nav-section">
              <h4 className="professional-footer__nav-title">Features</h4>
              <ul className="professional-footer__nav-list">
                <li><span className="professional-footer__nav-link">Multi-Stablecoin Support</span></li>
                <li><span className="professional-footer__nav-link">FPS Integration</span></li>
                <li><span className="professional-footer__nav-link">CIPS Settlement</span></li>
                <li><span className="professional-footer__nav-link">Provider Failover</span></li>
              </ul>
            </div>

            <div className="professional-footer__nav-section">
              <h4 className="professional-footer__nav-title">Support</h4>
              <ul className="professional-footer__nav-list">
                <li><span className="professional-footer__nav-link">Documentation</span></li>
                <li><span className="professional-footer__nav-link">API Reference</span></li>
                <li><span className="professional-footer__nav-link">Compliance Guide</span></li>
                <li><span className="professional-footer__nav-link">Contact Support</span></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="professional-footer__bottom">
          <div className="professional-footer__bottom-content">
            <div className="professional-footer__copyright">
              <Building2 className="professional-footer__copyright-icon" />
              <span>© {currentYear} StablePay. All rights reserved.</span>
            </div>
            <div className="professional-footer__legal">
              <span className="professional-footer__legal-link">Privacy Policy</span>
              <span className="professional-footer__legal-separator">•</span>
              <span className="professional-footer__legal-link">Terms of Service</span>
              <span className="professional-footer__legal-separator">•</span>
              <span className="professional-footer__legal-link">Compliance</span>
            </div>
          </div>
          <div className="professional-footer__demo-notice">
            <span className="professional-footer__demo-badge">DEMO MODE</span>
            <span className="professional-footer__demo-text">
              This is a demonstration environment with simulated data
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}